import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu } from '../Menu/Menu'

import {RiAccountCircleLine} from 'react-icons/ri'
import {FiSettings , FiLogOut} from 'react-icons/fi'
import {CgMenu, CgPushLeft} from 'react-icons/cg'
import './Navbar.css'
import { useDispatch, useSelector } from 'react-redux'
import { updateGeneralUI } from '../../Redux/features/uiReducer'
import  { GrUserSettings } from 'react-icons/gr'
export function Navbar({ breadcrumbs , chlidren }) {


	const profileMenu = [
		{
			name: 'Profile',
			link: '/profile',
			icon : <GrUserSettings />
		},
		{
			name: 'Organization Settings',
			link: '/settings',
			icon : <FiSettings />
		},
		// {
		// 	name: 'Billing',
		// 	link: '/settings/billing',
		// 	icon : <MdOutlinePayment />
		// },
		{
			name: 'Log out',
			link: '/logout',
			icon : <FiLogOut />,
			seperator : true
		}
	]

    const { general } = useSelector((state) => state.ui )
    const dispatch = useDispatch()

    // const [isOpen, setIsOpen] = useState(false)

	return (
		<nav className={`navbar ${general?.show_sidebar ? 'open' : ''}`}>
			<div className="container">
                <div className="sidebar-toggle-btn" onClick={() => dispatch(updateGeneralUI({ ...general , show_sidebar : (!general?.show_sidebar)}))}>
                    {
                        general?.show_sidebar ? <CgPushLeft width={24}/> : <CgMenu />
                    }
                </div>
				{
					breadcrumbs && breadcrumbs.length > 0 && 
					<div className="navbar-breadcrumbs-row">
						{breadcrumbs.map((item, index) => {
							
							return (
								<div className="navbar-breadcrumbs-row-item" key={index}>
									{
										item.link !=""
											? <Link className="active limited-text"  to={item.link} title={item.name} >{item.name}</Link>
											: <div className="d-inline limited-text" title={item.name} >{item.name}</div>
									}
								</div>
							)
						})}
					</div>
				}
				<div className="navbar-notice-wrapper" >
					{/* {this.state.trialPeriodMessage && 
						<span className="navbar-text navbar-upgrade-notice">{this.state.trialPeriodMessage} 
						{ this.state.isExpiredSubscription === true	&& 
							<Link to="/settings/billing"  > - Upgrade your plan</Link>
						}
						</span>
					} */}
				</div>
				<div className="navbar-collapse" >
					<ul className="ml-auto nav navbar-nav">
						<Menu 
                            transition="pop"
                            withArrow 
                            position="bottom-end"
                            data={
                                profileMenu
                               
                            }
                            target={<RiAccountCircleLine width={24}/>}
                            />
							
					</ul>
				</div>
			</div>
		</nav>
	)
}

 